import {BaseContainerModel} from '../base-container.model';
import { bl_module_applet_link_RowClass } from '../../dbschema/bl_module_applet_link.model';

export class AppletModuleLinkModel extends BaseContainerModel {
    bl_module_applet_link: bl_module_applet_link_RowClass = new bl_module_applet_link_RowClass();
}
